export default __webpack_public_path__ + "static/media/suitcase_gif.754d9530.gif";